import React from 'react'
import './styles.scss'
const f = new Intl.NumberFormat('de-CH')

interface Props {
  title?: string
  source: string
  segments: {
    label: string
    value: number
    color?: string
    textColor?: string
    labelInside?: boolean
    position?: 'bottom left' | 'bottom right' | 'top left' | 'top right'
    offset?: number
    isOverlay?: boolean
  }[]
}

export const Bar2 = ({ title, source, segments }: Props) => {
  let hasTopFlags = false
  let currentStart = 0

  if (segments) {
    hasTopFlags = segments.some(s => s.position?.includes('top'))
  }
  return (
    <div className='Bar'>
      {title && <div className='title'>{title}</div>}
      <div className={'barContainer ' + (hasTopFlags && 'top')}>
        {segments &&
          segments.map(segment => {
            const {
              value,
              label,
              color,
              textColor,
              labelInside,
              position = 'bottom right',
              offset = 0,
              isOverlay
            } = segment
            const labelComp = label != '' && label != undefined && (
              <div className={!labelInside ? 'label' : 'label inside'}>
                {label}: <span>{f.format(value).replace('.', ',')}%</span>
              </div>
            )
            currentStart = !isOverlay ? currentStart + value : currentStart
            return (
              <div
                className={!isOverlay ? 'barSegment' : 'barSegment hatched'}
                style={{
                  width: value + '%',
                  left: !isOverlay ? currentStart - value + '%' : 0
                }}
              >
                <div
                  className='barArea'
                  style={{ backgroundColor: color, color: textColor }}
                >
                  {labelInside && labelComp}
                </div>
                {!labelInside && label != '' && label != undefined && (
                  <div
                    className={'flag ' + position}
                    style={{ marginLeft: offset + 'px' }}
                  >
                    <div className='content' style={{ color: textColor }}>
                      {labelComp}
                    </div>
                  </div>
                )}
              </div>
            )
          })}
        <div className='source'>Quelle: {source}</div>
      </div>
    </div>
  )
}
